// extracted by css-extract-rspack-plugin
export default {"bui-Popover":"c6K43dAXzUIQYTPO","bui-PopoverArrow":"nWNOVN9SSAkDCJc4","bui-PopoverContent":"ndXnur8atSwrX9tW"};